import { connect } from 'react-redux';
import { RefundApproverComponent } from '../../components';
import { getRefundRequestedData, addComment, updateStatus, uploadFiles, getRefundsCount, getTransactions, switchMethod } from '../../redux/actions/refunds';
import { getAllOperatorData as getOperatorData } from '../../redux/actions/operator';
import { notifyUser } from '../../redux/actions/notification';

const mapStateToProps = state => ({
  refunds: state.refunds.data,
  operators: state.operator.allData,
  loading: state.refunds.loading,
  uploading: state.refunds.uploading,
  refundCount: state.refunds.refundCount,
  transactions: state.refunds.transactions,
  loadingTransactions: state.refunds.loadingTransactions
})

const mapDispatchToProps = {
  getRefundData: getRefundRequestedData,
  addComment,
  updateStatus,
  getOperatorData,
  notifyUser,
  uploadFiles,
  getRefundsCount,
  getTransactions,
  switch: switchMethod
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RefundApproverComponent)



// WEBPACK FOOTER //
// ./src/containers/RefundApprover/RefundApprover.js